<template>
  <div class="product-characteristics">
    <div
      v-for="characteristic in props.product.attributes.characteristics"
      :key="characteristic.id"
      class="product-characteristics-item"
      :title="characteristic.title"
    >
      <div class="product-characteristics-item__value-wrapper">
        <ProductCharacteristicsStar
          :rating="characteristic.value"
          :size="56"
          class="product-characteristics-item__star"
        />

        <div class="product-characteristics-item__value">
          {{ characteristic.value }}
        </div>
      </div>

      <div class="product-characteristics-item__title">{{ characteristic.title }}</div>
    </div>

    <div
      v-if="!props.product.attributes.characteristics.length"
      class="product-characteristics__empty"
    >
      У данного товара нет характеристик
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Product } from '@/services/product/types';
  import ProductCharacteristicsStar from './inner/ProductCharacteristicsStar.vue';

  const props = defineProps<{
    product: Product;
  }>();
</script>

<style>
  .product-characteristics {
    display: flex;
    flex-direction: row;
    gap: 32px;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 42px;

    &__empty {
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      height: 100%;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .product-characteristics-item {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: calc(25% - 24px);

    &__value-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }

    &__value {
      font-size: 36px;
      font-weight: 700;
      color: #000000;
    }

    &__title {
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .product-characteristics-item__value {
    display: flex;
    gap: 14px;
  }

  @media (--mobile) {
    .product-characteristics {
      flex-direction: column;

      .product-characteristics__empty {
        white-space: normal;
      }

      &-item {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;

        &__value-wrapper {
          flex-direction: row;
        }

        &__value {
          width: 80px;
        }

        &__title {
          font-size: 22px;
          order: -1;
          font-weight: 600;
        }
      }
    }
  }
</style>
